export enum TalkVolume {
  TALK = 0,
  WHISPER = 1,
  SHOUT = 2,
  SILENT_TALK = 3,
  SILENT_SHOUT = 4,
}